/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getDiscriminatedUnionDecoder,
  getDiscriminatedUnionEncoder,
  getI128Decoder,
  getI128Encoder,
  getI16Decoder,
  getI16Encoder,
  getI32Decoder,
  getI32Encoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  type Codec,
  type Decoder,
  type Encoder,
  type GetDiscriminatedUnionVariant,
  type GetDiscriminatedUnionVariantContent,
} from '@solana/kit';
import {
  getEquatableOperatorDecoder,
  getEquatableOperatorEncoder,
  getIntegerOperatorDecoder,
  getIntegerOperatorEncoder,
  type EquatableOperator,
  type EquatableOperatorArgs,
  type IntegerOperator,
  type IntegerOperatorArgs,
} from '.';

export type DataValueDeltaAssertion =
  | { __kind: 'U8'; value: number; operator: IntegerOperator }
  | { __kind: 'I8'; value: number; operator: IntegerOperator }
  | { __kind: 'U16'; value: number; operator: IntegerOperator }
  | { __kind: 'I16'; value: number; operator: IntegerOperator }
  | { __kind: 'U32'; value: bigint; operator: IntegerOperator }
  | { __kind: 'I32'; value: bigint; operator: IntegerOperator }
  | { __kind: 'U64'; value: bigint; operator: IntegerOperator }
  | { __kind: 'I64'; value: bigint; operator: IntegerOperator }
  | { __kind: 'Bytes'; length: number; operator: EquatableOperator };

export type DataValueDeltaAssertionArgs =
  | { __kind: 'U8'; value: number; operator: IntegerOperatorArgs }
  | { __kind: 'I8'; value: number; operator: IntegerOperatorArgs }
  | { __kind: 'U16'; value: number; operator: IntegerOperatorArgs }
  | { __kind: 'I16'; value: number; operator: IntegerOperatorArgs }
  | { __kind: 'U32'; value: number | bigint; operator: IntegerOperatorArgs }
  | { __kind: 'I32'; value: number | bigint; operator: IntegerOperatorArgs }
  | { __kind: 'U64'; value: number | bigint; operator: IntegerOperatorArgs }
  | { __kind: 'I64'; value: number | bigint; operator: IntegerOperatorArgs }
  | { __kind: 'Bytes'; length: number; operator: EquatableOperatorArgs };

export function getDataValueDeltaAssertionEncoder(): Encoder<DataValueDeltaAssertionArgs> {
  return getDiscriminatedUnionEncoder([
    [
      'U8',
      getStructEncoder([
        ['value', getI16Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'I8',
      getStructEncoder([
        ['value', getI16Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'U16',
      getStructEncoder([
        ['value', getI32Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'I16',
      getStructEncoder([
        ['value', getI32Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'U32',
      getStructEncoder([
        ['value', getI64Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'I32',
      getStructEncoder([
        ['value', getI64Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'U64',
      getStructEncoder([
        ['value', getI128Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'I64',
      getStructEncoder([
        ['value', getI128Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'Bytes',
      getStructEncoder([
        ['length', getU16Encoder()],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
  ]);
}

export function getDataValueDeltaAssertionDecoder(): Decoder<DataValueDeltaAssertion> {
  return getDiscriminatedUnionDecoder([
    [
      'U8',
      getStructDecoder([
        ['value', getI16Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'I8',
      getStructDecoder([
        ['value', getI16Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'U16',
      getStructDecoder([
        ['value', getI32Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'I16',
      getStructDecoder([
        ['value', getI32Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'U32',
      getStructDecoder([
        ['value', getI64Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'I32',
      getStructDecoder([
        ['value', getI64Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'U64',
      getStructDecoder([
        ['value', getI128Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'I64',
      getStructDecoder([
        ['value', getI128Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'Bytes',
      getStructDecoder([
        ['length', getU16Decoder()],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
  ]);
}

export function getDataValueDeltaAssertionCodec(): Codec<
  DataValueDeltaAssertionArgs,
  DataValueDeltaAssertion
> {
  return combineCodec(
    getDataValueDeltaAssertionEncoder(),
    getDataValueDeltaAssertionDecoder()
  );
}

// Data Enum Helpers.
export function dataValueDeltaAssertion(
  kind: 'U8',
  data: GetDiscriminatedUnionVariantContent<
    DataValueDeltaAssertionArgs,
    '__kind',
    'U8'
  >
): GetDiscriminatedUnionVariant<DataValueDeltaAssertionArgs, '__kind', 'U8'>;
export function dataValueDeltaAssertion(
  kind: 'I8',
  data: GetDiscriminatedUnionVariantContent<
    DataValueDeltaAssertionArgs,
    '__kind',
    'I8'
  >
): GetDiscriminatedUnionVariant<DataValueDeltaAssertionArgs, '__kind', 'I8'>;
export function dataValueDeltaAssertion(
  kind: 'U16',
  data: GetDiscriminatedUnionVariantContent<
    DataValueDeltaAssertionArgs,
    '__kind',
    'U16'
  >
): GetDiscriminatedUnionVariant<DataValueDeltaAssertionArgs, '__kind', 'U16'>;
export function dataValueDeltaAssertion(
  kind: 'I16',
  data: GetDiscriminatedUnionVariantContent<
    DataValueDeltaAssertionArgs,
    '__kind',
    'I16'
  >
): GetDiscriminatedUnionVariant<DataValueDeltaAssertionArgs, '__kind', 'I16'>;
export function dataValueDeltaAssertion(
  kind: 'U32',
  data: GetDiscriminatedUnionVariantContent<
    DataValueDeltaAssertionArgs,
    '__kind',
    'U32'
  >
): GetDiscriminatedUnionVariant<DataValueDeltaAssertionArgs, '__kind', 'U32'>;
export function dataValueDeltaAssertion(
  kind: 'I32',
  data: GetDiscriminatedUnionVariantContent<
    DataValueDeltaAssertionArgs,
    '__kind',
    'I32'
  >
): GetDiscriminatedUnionVariant<DataValueDeltaAssertionArgs, '__kind', 'I32'>;
export function dataValueDeltaAssertion(
  kind: 'U64',
  data: GetDiscriminatedUnionVariantContent<
    DataValueDeltaAssertionArgs,
    '__kind',
    'U64'
  >
): GetDiscriminatedUnionVariant<DataValueDeltaAssertionArgs, '__kind', 'U64'>;
export function dataValueDeltaAssertion(
  kind: 'I64',
  data: GetDiscriminatedUnionVariantContent<
    DataValueDeltaAssertionArgs,
    '__kind',
    'I64'
  >
): GetDiscriminatedUnionVariant<DataValueDeltaAssertionArgs, '__kind', 'I64'>;
export function dataValueDeltaAssertion(
  kind: 'Bytes',
  data: GetDiscriminatedUnionVariantContent<
    DataValueDeltaAssertionArgs,
    '__kind',
    'Bytes'
  >
): GetDiscriminatedUnionVariant<DataValueDeltaAssertionArgs, '__kind', 'Bytes'>;
export function dataValueDeltaAssertion<
  K extends DataValueDeltaAssertionArgs['__kind'],
  Data,
>(kind: K, data?: Data) {
  return Array.isArray(data)
    ? { __kind: kind, fields: data }
    : { __kind: kind, ...(data ?? {}) };
}

export function isDataValueDeltaAssertion<
  K extends DataValueDeltaAssertion['__kind'],
>(
  kind: K,
  value: DataValueDeltaAssertion
): value is DataValueDeltaAssertion & { __kind: K } {
  return value.__kind === kind;
}
